import {
  NotificationIntent,
  type NotificationProps,
} from './Notification.typed';
import type { IconName } from '../Icon/Icon.typed';
import * as Styled from './Notification.styled';

const getIconName = (intent: NotificationIntent): IconName => {
  switch (intent) {
    case NotificationIntent.ERROR:
      return 'AlertCircleOutline';
    default:
      return 'InformationCircleOutline';
  }
};

export const Notification = (props: NotificationProps) => {
  const {
    intent = NotificationIntent.INFO,
    iconSize,
    children,
    ...rest
  } = props;
  const iconName = getIconName(intent);

  return (
    <Styled.Wrapper {...rest}>
      <Styled.Icon
        size={iconSize ? iconSize : 's'}
        intent={intent}
        name={iconName}
        aria-hidden="true"
      />
      <Styled.Text intent={intent}>{children}</Styled.Text>
    </Styled.Wrapper>
  );
};

export default Notification;
